import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-RateLimiting',
    templateUrl: './RateLimiting.component.html'
})
export class RateLimitingComponent implements OnInit {

    consumerID: string;
    second = 100;
    minute = 100;
    hour = 100;
    day = 100;
    month = 100;
    year = 100;
    fault_tolerant = true;
    redis_host: string;
    redis_port = 6379;
    redis_password: string;
    redis_timeout = 2000;
    redis_database: number;
    hide_client_headers = false;
    selected: string;
    policy = 'cluster';
    limit_by = 'consumer';

    data = {
        'consumerID' : this.consumerID,
        'second' : this.second,
        'minute' : this.minute,
        'hour' : this.hour,
        'day' : this.day,
        'month' : this.month,
        'year' : this.year,
        'fault_tolerant' : this.fault_tolerant,
        'redis_host' : this.redis_host,
        'redis_port' : this.redis_port,
        'redis_password' : this.redis_password,
        'redis_timeout' : this.redis_timeout,
        'redis_database' : this.redis_database,
        'hide_client_headers' : this.hide_client_headers,
        'policy' : this.policy,
        'limit_by' : this.limit_by,
        'plugin' : 'rate-limiting'
    };

    constructor() { }

    slider() {
        this.fault_tolerant = !this.fault_tolerant;
    }
    slider1() {
        this.hide_client_headers = !this.hide_client_headers;
    }

    RateLimiting() {
    }

    ngOnInit() {
    }

}
